import ListTableMainCell from '../../../components/list-table-main-cell/list-table-main-cell.component';
import { displayCellValue } from '../../../utils/column-values.util';

export const HELP_ONBOARDING_STEPS_COLUMNS = [
    {
        Header: "Title",
        accessor: "title",
        style: {
            position: "sticky",
            left: 0,
            top: 0,
            zIndex: 2
        },
        Cell: ({ value, row }) => {
            const uuid = row.original.uuid;
            return (
                <ListTableMainCell
                    value={value}
                    uuid={uuid}
                />
            )
        }
    },
    {
        Header: "Sort Order",
        accessor: "sortOrder",
        Cell: ({ value }) => displayCellValue(value)
    },
    {
        Header: "Section",
        accessor: "sectionTitle",
        Cell: ({ value }) => displayCellValue(value)
    },
    {
        Header: "Description",
        accessor: "desc",
        Cell: ({ value }) => displayCellValue(value)
    },
]
